import { func, number, string } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

CreatedBy.propTypes = {
  onClick: func,
  createdByName: string,
  createdByPhotoURL: string,
  createdByUserID: number,
};

export default function CreatedBy({
  onClick,
  createdByUserID,
  createdByPhotoURL,
  createdByName,
}) {
  if (!createdByUserID || !createdByName) return null;

  return (
    <Wrapper>
      Made by
      <UserLink
        onClick={onClick}
        className={`can_mini_profile can_mini_profile_ +${createdByUserID}`}
        data-userid={createdByUserID}
      >
        <UserPhoto
          style={{
            backgroundImage: `url("${createdByPhotoURL}")`,
          }}
        />
        <StrongStyle>{createdByName}</StrongStyle>
      </UserLink>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 0.75rem;
  margin-top: 1rem;

  @media (max-width: 560px) {
    // things get too crowded on small screens if buttons are showing, so hiding this.
    display: none;
  }
`;

const UserPhoto = styled.div`
  width: 24px;
  height: 24px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 32px;
  border: 1px solid #fff;
  box-shadow: rgba(0, 0, 0, 0.4) 1px 1px 3px;
  margin: 0 6px;
`;

const UserLink = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const StrongStyle = styled.span`
  font-weight: 400;
`;
